// ** React Imports
import { useMemo } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import VipStatus from "components/user/VipStatus";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// ** Custom Filters
import { compute as filterContentCompute } from "hooks/filters/useFilterContent";

// #####################################################

const useContentFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	const query = useQuery();

	const { only: onlyUrl } = query || {};

	// ** Filtr - Tylko z ... ("Content")
	const contentFilterData = useMemo(() => {
		const contentItemsKeysArray =
			filterContentCompute(true).urlToKeysArray(onlyUrl) || [];

		// ** Wyłaczenie wyświetlania wybranych opcji: 'Vip' i 'SuperVip'
		// ** w przypadku gdy zaznaczono opcję 'Tylko: Zweryfikowani'
		/*
		if (contentItemsKeysArray.some((item) => item === "verified")) {
			if (contentItemsKeysArray.some((item) => item === "vip")) {
				const vipItemIndex = contentItemsKeysArray.findIndex(
					(item) => item === "vip"
				);
				contentItemsKeysArray.splice(vipItemIndex, 1);
			}
			if (contentItemsKeysArray.some((item) => item === "superVip")) {
				const superVipItemIndex = contentItemsKeysArray.findIndex(
					(item) => item === "superVip"
				);
				contentItemsKeysArray.splice(superVipItemIndex, 1);
			}
		}

		// ** Wyłaczenie wyświetlania wybranej opcji: 'SuperVip'
		// ** w przypadku gdy zaznaczono opcję 'Tylko: Vip'
		if (contentItemsKeysArray.some((item) => item === "vip")) {
			if (contentItemsKeysArray.some((item) => item === "superVip")) {
				const superVipItemIndex = contentItemsKeysArray.findIndex(
					(item) => item === "superVip"
				);
				contentItemsKeysArray.splice(superVipItemIndex, 1);
			}
		}
		*/

		const contentItems = () =>
			contentItemsKeysArray.map((contentItemKey, index) => {
				if (contentItemKey === "verified") {
					return (
						<>
							{t(`filtersAndSelectors:only.${contentItemKey}`)}
							<>
								{" "}
								<VipStatus status={2} noPad height={14} />
							</>
							{contentItemsKeysArray.length === index + 1
								? ""
								: ", "}
						</>
					);
				}
				if (contentItemKey === "vip") {
					return (
						<>
							{t(`filtersAndSelectors:only.${contentItemKey}`)}
							<>
								{" "}
								<VipStatus status={3} noPad height={14} />
							</>
							{contentItemsKeysArray.length === index + 1
								? ""
								: ", "}
						</>
					);
				}
				if (contentItemKey === "superVip") {
					return (
						<>
							{t(`filtersAndSelectors:only.${contentItemKey}`)}
							<>
								{" "}
								<VipStatus status={5} noPad height={14} />
							</>
							{contentItemsKeysArray.length === index + 1
								? ""
								: ", "}
						</>
					);
				}
				return (
					<>
						{t(`filtersAndSelectors:only.${contentItemKey}`)}
						{contentItemsKeysArray.length === index + 1 ? "" : ", "}
					</>
				);
			});

		return onlyUrl
			? {
					label: t("filtersAndSelectors:onlyLabel"),
					selected: contentItems,
			  }
			: null;
	}, [onlyUrl, language]);

	// #####################################################

	return contentFilterData;
};

// #####################################################

export default useContentFilterData;

// #####################################################
